export default function About() {
  return (
    <section id="about" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-secondary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            关于本站
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-5">
              51吃瓜黑料 · 全网吃瓜根据地
            </h3>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                51吃瓜黑料成立于2024年，是国内领先的网红娱乐资讯聚合平台。我们专注于追踪网红塌房黑料、明星爆料、网曝门事件以及博主反差记录，为全网吃瓜爱好者提供最新最全的爆料内容与深度解读。
              </p>
              <p>
                网站保持24小时不打烊更新机制，编辑团队全天候监测全网动态。从微博热搜到短视频平台，从匿名投稿到公开报道，51吃瓜黑料网址入口汇聚海量吃瓜资源，让你一次吃过瘾。
              </p>
              <p>
                我们坚持「不做谣言的制造者，只做信息的搬运工」原则，所有爆料内容均基于公开信息整理发布。51吃瓜黑料在线观看与视频入口持续优化，致力于为你带来最佳的浏览体验。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                <span className="whitespace-nowrap">实时更新不打烊</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                <span className="whitespace-nowrap">全网热门聚合</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                <span className="whitespace-nowrap">移动端完美适配</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-gradient-to-br from-background-900 to-background-800 flex items-center justify-center">
              <div className="text-center p-8">
                <div className="text-5xl font-heading text-primary-400 mb-3">51</div>
                <p className="text-background-300 text-sm">吃瓜黑料</p>
                <div className="mt-6 flex items-center justify-center gap-6">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-white">12,680+</div>
                    <div className="text-xs text-background-400 mt-1 whitespace-nowrap">累计爆料</div>
                  </div>
                  <div className="w-px h-10 bg-background-700"></div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-white">24h</div>
                    <div className="text-xs text-background-400 mt-1 whitespace-nowrap">全天更新</div>
                  </div>
                  <div className="w-px h-10 bg-background-700"></div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-white">100+</div>
                    <div className="text-xs text-background-400 mt-1 whitespace-nowrap">日更条目</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}